/* eslint-disable no-unused-vars */
import { get } from 'lodash';
import { conditionsMsg, caseLogicMsg } from '../validationMessages';

function validateBehaviorNodes(caseConf, nodeInfo) {
  const errors = [];

  const startsHelicopter = caseConf._startLocation.key === 'HELICOPTER';
  const endsHelicopter = (caseConf._endLocation && caseConf._endLocation.key === 'HELICOPTER');

  if (startsHelicopter || endsHelicopter) {
    // Look at behavior effects to compute if sit and non-sit positions are used
    let isNonSit = false;
    nodeInfo.effectNodes.forEach(node => {
      const { effect } = node.data;
      if (effect && ['ANIMATION_ONE_SHOT', 'ANIMATION_REPEAT'].includes(effect.type)) {
        if (effect.position !== 'SIT') {
          isNonSit = true;
        }
      }
    });
    if (!isNonSit) {
      let scenarioLogicError = false;
      nodeInfo.effectNodes.forEach(node => {
        const { effect } = node.data;
        if (effect && ['ANIMATION_ONE_SHOT', 'ANIMATION_REPEAT'].includes(effect.type) && effect.position === 'SIT') {
          scenarioLogicError = true;
          errors.push(
            caseLogicMsg('Patient cannot only be placed in the seated position when a scene is Helicopter', node.id, { warningId: 'helicopterStance' })
          );
        }
      });
      if (!scenarioLogicError && endsHelicopter) {
        const positionState = caseConf._initialStates.find(state => state.id === 'position');
        const startingPosition = get(positionState, 'options.value');
        if (startingPosition === 'SIT') {
          errors.push(
            conditionsMsg('Patient is in seated forward position and ending scene is Helicopter')
          )
        }
      }
    }
  }

  return {
    errors,
    warnings: [],
  };
}

export default validateBehaviorNodes;